import { Button, Typography } from "@mui/material";
import React, { Component } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import MyTextField from "./MyTextField";

class OTPConfirm extends Component {
  state = {};
  render() {
    const { backToLogin, handleOTPConfirm, handleChange } = this.props;
    return (
      <Box sx={{ width: "100%" }}>
        <Stack
          sx={{ bottom: 30, right: 15, left: 15, position: "fixed" }}
          spacing={2}
        >
          <Typography>کد فعالسازی ارسالی را وارد کنید</Typography>

          <MyTextField
            label="کد فعالسازی"
            type="tel"
            onChange={(e) => handleChange(e, "OTP")}
          />
          <Button variant="contained" onClick={handleOTPConfirm}>
            ارسال
          </Button>
          <Button variant="outlined" onClick={backToLogin}>
            بازگشت به فرم ورود
          </Button>
        </Stack>
      </Box>
    );
  }
}

export default OTPConfirm;
